import React, { Component } from "react";
import { Grid, Col, Row, Panel, Table, FormGroup, Button } from "react-bootstrap";
import Parse from 'parse';
import './Dashboard.css';
import {Admin} from './../../configurations/Admin';
import CircularButton from "../Components/Presentation/CircularButton/CircularButton";
import PrimaryButton from "../Components/Presentation/PrimaryButton/PrimaryButton";



class Dashboard extends Component {
  currentUser = Parse.User.current();

  constructor(props){
    super(props);
    

    this.state = {
      patients: null,
      isLoading:false
    }
  }

  componentDidMount = async () => {
    if(!this.currentUser || this.currentUser === null){
      this.props.history.push( `/pages/log-out`);
      return;
    }

    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);
    
    if(this.currentUser.get("username") !== Admin.user_admin){
      query.equalTo("doctor", this.currentUser);
    }

    //Load in
    this.setState({isLoading:true});

    let result = await query.find();

    this.setState({isLoading:false});

    //Load out

    this.setState({patients: result});
  }

  getActionButton = (id) => {
    return (
      <PrimaryButton 
        onClick={() => { 
          this.props.history.push( `forms/newform/${id}`)
        }}
        text="Más información"
      />
  )}

  getGridDataRows = (data) => {
    let rows = [];
    if(data && data.length > 0){
      let index=1;
      data.map( (patient, key) => {
        rows.push (
          <tr key={key}>
            <td className="text-center">{index}</td>
            <td>{patient.get("name")}</td>
            <td className="hidden-xs">{patient.get("email")}</td>
            <td>{this.getActionButton(patient.id)}</td>
          </tr>
        );
        index+=1;
      });
      return rows;
    }
    return <p>Pacientes no encontrados</p>;
  }

  searchChangeHandler = async (evt) => {
    const {value} = evt.target;

    let currentUser = Parse.User.current();

    const Patient = Parse.Object.extend('Patient');
    const query = new Parse.Query(Patient);

    if(currentUser.get("username") !== Admin.user_admin){
      query.equalTo("doctor", currentUser);
    }
    query.contains("tags", value.toLowerCase());
    
    this.setState({isLoading:true});
    
    let result = await query.find();

    this.setState({patients: result, isLoading: false});
  }

  render() {
    let currentUser = Parse.User.current();
    if(currentUser === null){
      this.props.history.push( `pages/log-out`);
      return;
    }
    let isUserAdmin = (currentUser.get("username") === Admin.user_admin);
    const { patients } = this.state;
    let body;

    if(patients === null){
      body= (
        <Row className="dashboard-container">
          <Col md={10} mdOffset={1}>
            <Panel>
              <Row>
                <Col md={10} mdOffset={1}>
                  <div className="vertical-separator-20px"></div>
                  <p>No se han encontrado paciente, agrega un paciente dando click en el botón agregar.</p>
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      )
    }else{
      let gridData = this.getGridDataRows(patients);
      body= (
        <Row>
          <Col md={10} mdOffset={1}>
            <div className="vertical-separator-20px"></div>
            <Table responsive>
                <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th>Nombre</th>
                        <th  className="hidden-xs">Email</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {gridData}
                </tbody>
            </Table>
          </Col>
        </Row>
      )
    }

    return (
      <div>
        <div className="vertical-separator-20px"></div>
        <Grid>
          <Panel>
            <Row>
              <div className="vertical-separator-20px"></div>

              <Col md={6} mdOffset={1} xs={9}>
                <div class="form-group">
                  <input
                    type="text" 
                    class="form-control" 
                    id="search" 
                    aria-describedby="search" 
                    placeholder="Buscar paciente por nombre ó email"
                    onChange={this.searchChangeHandler}                  
                  />
                </div>
              </Col>
              {isUserAdmin ? null:
                <Col md={3} mdOffset={2} xs={2}>
                  <CircularButton
                    onClick={()=> { 
                      this.props.history.push( `forms/newform/0`)
                    }}
                    icon="fa fa-plus"
                  />
                </Col>
              }
            </Row>
            {body}
          </Panel>                  
        </Grid>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx